module.exports = __webpack_public_path__ + "img/bt2_act.e15acbd5.png";